import request from "./request";
import apis from "./apis";

const {
  transcriptList,
  transcriptListImport,
} = apis.transcript;

const transcript = {
  getTranscriptList: (data: Object) => {
    return request.post(transcriptList, data);
  },
  updateTranscript: (data: Object) => {
    return request.put(transcriptList, data);
  },
  importTranscriptFile: (data: Object) => {
    return request.formJsonPost(transcriptListImport, data);
  },
};

export default transcript;